import { cva } from 'class-variance-authority';

export const cvaAltInput = cva([
  'AltInputStyles-cvaAltInput',
  'block',
  'w-full h-5',
  'my-2.4 pb-1.2',
  'text-cWhite text-[3.2rem] font-bold  border-cSecondaryGray  bg-transparent border-b-[3px] rounded-none focus-visible:outline-none placeholder:text-cSecondaryGray',
]);

export const cvaInput = cva(
  [
    'InputStyles-cvaInput',
    'flex-1',
    'w-full',
    'p-1.5',
    'bg-transparent',
    'border-[3px] border-cSecondaryGray rounded-[0.8rem]',
    'text-cWhite placeholder:text-cGray focus-visible:outline-none',
  ],
  {
    variants: {
      error: {
        true: ['border-cRed'],
      },
      textarea: {
        true: ['!text-[1.6rem] min-h-[13.2rem]'],
        false: 'text-l-b',
      },
    },
  }
);
